import { gql } from "@apollo/client";

export const JUSTIFICAR_MASIVA = gql`
  mutation JustificarMasiva ($input: [ListarJustificacionMasivaInput!]!, $idDelegacion: Int!
  ){
    justificarMasiva(input: $input, idDelegacion: $idDelegacion) {
      success,
      valorEsperado,
      error
    }
}
`;